// import { useTranslation } from "react-i18next";

import { SignupSummaryExternalTraining } from "../../components/SignupSummary";
// import { AddSkillBook } from "../../routes/Profile/ExternalTrainingAddSkillbook";
// import { useAuthStore } from "../../stores";


export function ContentExternalTraining (){
  
  // const { t }=useTranslation();
  return (
    <>
      <SignupSummaryExternalTraining/>
    </>
  );
}
